export const useState = {
    0: '未使用',
    1: '已使用'
}
export const unit = {
    1: '公里',
    2: "小时",
    3: "重量/吨", 
    0: '其他',
}
export const fenceType = {
    1: '禁出',
    2: '禁入'
}
export const workStatus = {
    0: '缺勤',
    1: '正常'
}
export const isp = {
    1: '电信',
    2: '移动',
    3: "联通",
    0: "其他"
}
export const checkType = {
    1: '日巡',
    2: '夜巡',
}
export const roleType = {
    0: '通用',
    1: '私用',
}
export const flowStatus = {
    0: '正常',
    1: '停用',
}
export const personbanci = ['轮班', '固定']
export const cmdType = [
    { tab: 1, name: 'TTS文本消息' },
    { tab: 2, name: '点名位置查询' },
    { tab: 3, name: '初始终端里程' },
    { tab: 4, name: '设置终端车牌' },
    { tab: 5, name: '取消终端报警' },
];

export const cmdParamid = {
    1: '显示屏显示',
    2: 'TTS语音播报',
    3: '显示屏显示和TTS语音播报',
    4: '文本指令'
}
export const cmdStatus = {
    0: '已下发终端',
    1: '下发终端成功',
    2: '下发终端失败',
    3: '执行成功',
    4: '执行失败',
}
export const signSource = {
    0: '其他',
    1: '平台',
    2: '客户端',
    3: '车载终端',
    4: '人员工牌',
}
export const applyStatus = {
    0: '待审',
    1: '通过',
    2: '驳回',
    3: '作废',
}
export const isPass = {
    0: '不合格',
    1: '合格'
}
export const sign = {
    0: '区域内',
    1: '区域外',
    null: '',
}
export const bool = {
    true: '是',
    false: '否'
}
export const useType = {
    null: '-',
    0: '其他',
    1: '车载定位',
    2: '人员定位',
    3: '设施定位',
}
export const roleData = {
    1: '所有',
    2: '所在部门及以下',
    3: '所在部门',
    4: '本人',
}
export const businessType = ['清扫保洁', '垃圾清运', '综合巡查', '绿化管养'];
export const source = ['市民上报', '甲方指派', '员工上报', '呼叫工单', '巡检上报', '数字化城管'];
export const banciType = ['其他', '大扫'];
export const grade = ['一级', '二级', "三级"];
export const roadType = ['单向车道', '双向车道'];
export const times = [
    '00:00', '00:30',
    '01:00', '01:30',
    '02:00', '02:30',
    '03:00', '03:30',
    '04:00', '04:30',
    '05:00', '05:30',
    '06:00', '06:30',
    '07:00', '07:30',
    '08:00', '08:30',
    '09:00', '09:30',
    '10:00', '10:30',
    '11:00', '11:30',
    '12:00', '12:30',
    '13:00', '13:30',
    '14:00', '14:30',
    '15:00', '15:30',
    '16:00', '16:30',
    '17:00', '17:30',
    '18:00', '18:30',
    '19:00', '19:30',
    '20:00', '20:30',
    '21:00', '21:30',
    '22:00', '22:30',
    '23:00', '23:30'
];
export const weilan = {
    0: '车辆',
    1: '人员',
}
export const applyType = {
    0: '请假',
    1: '加班',
    2: '调班',
    3: '调休',
}
export const attdType = {
    0: '事假',
    1: '病假',
    2: '婚假',
    3: '产假',
    4: '年假',
    5: '丧假',
    100: '无',
}
export const status = {
    0: '待审',
    1: '已审',
    2: '驳回',
    3: '作废',
}
export const level = {
    1: '高',
    2: '中',
    3: '低',
}
export const accStatus = {
    0: '熄火',
    1: '启动',
}
export const flag = {
    0: '无',
    1: '有',
}
export const carState = {
    1: '正常',
    2: '维修',
    3: '报废',
}
export const signState = {
    0: '解约',
    1: '签约',
}
export const sex = {
    0: '保密',
    1: '男',
    2: '女',
}
export const payStatus = {
    1: { name: '待审核', color: 'ly-yellow' },
    2: { name: '已撤回', color: 'ly-gray' },
    3: { name: '已审核', color: 'ly-green' },
    4: { name: '已驳回', color: 'ly-red' },
}
export const times1 = [
    { value: 0, name: '立即触发' },
    { value: 60, name: '1分钟' },
    { value: 120, name: '2分钟' },
    { value: 180, name: '3分钟' },
    { value: 300, name: '5分钟' },
    { value: 600, name: '10分钟' }
]
export const meters = [
    { value: 0, name: '0米' },
    { value: 5, name: '5米' },
    { value: 10, name: '10米' },
    { value: 20, name: '20米' },
    { value: 50, name: '50米' },
    { value: 100, name: '100米' },
    { value: 200, name: '200米' },
    { value: 500, name: '500米' },
    { value: 800, name: '800米' },
    { value: 1000, name: '1000米' },
    { value: 1500, name: '1500米' },
    { value: 2000, name: '2000米' },
    { value: 5000, name: '5公里' },
    { value: 10000, name: '10公里' }
]
export const eventStatus = {
    0: '事件派遣',
    1: '待处理',
    2: '已处理',
    3: '待复核',
    4: '已复核',
    5: '结案',
}
export const orderType = {
    0: '事件派单',
    1: '复核派单',
}




// WEBPACK FOOTER //
// ./src/components/lang/zh.js